import {AfterViewInit, ChangeDetectorRef, Directive, inject, Injector, OnDestroy, ViewChild} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import {each, extend} from 'lodash-es';
import { FragmentMonitor } from "../util/fragment-monitor";
import { App, muteWatchers, noop, registerFnByExpr, runtimeEventManager, ScriptLoaderService, unMuteWatchers, UtilsService } from '@wm/core';
import { AppManagerService } from "../services/app.manager.service";
import { PageDirective } from '@wm/design-runtime';

import { commonPartialWidgets } from './base-partial.component';
import { BaseVariableService } from "@wms/variables";
import { I18nService } from '@wms/services';


@Directive()
export abstract class BasePageComponent extends FragmentMonitor implements AfterViewInit {
  static lastPageSnapShot = null;
  Widgets: any;
  Actions: any;
  App: App;
  // injector: Injector;
  pageName: string;
  activePageName: string;
  route: ActivatedRoute;
  appManager: AppManagerService;
  router: Router;
  pageParams: any;
  showPageContent: boolean;
  i18nService: I18nService;
  startupVariablesLoaded = false;
  pageTransitionCompleted = false;
  @ViewChild(PageDirective) pageDirective: PageDirective;
  $page: any;
  private cdRef: ChangeDetectorRef;
  // scriptLoaderService: ScriptLoaderService;
  // Viewport: Viewport;

  destroy$: Subject<any> = new Subject();
  // override viewInit$ = new Subject();

  abstract evalUserScript(prefabContext: any, appContext: any, utils: any): any;
  abstract getVariables(): any;
  abstract getExpressions(): any;

  onPageContentReady: Function = noop;

  onReady() {}

  private baseVariableService: BaseVariableService;
  override init() {
    muteWatchers();
    this.cdRef = inject(ChangeDetectorRef);
    this.App = inject(App);
    this.route = inject(ActivatedRoute);
    this.appManager = inject(AppManagerService);
    // this.scriptLoaderService = inject(ScriptLoaderService);
    this.i18nService = inject(I18nService);
    this.router = inject(Router);
    this.baseVariableService = inject(BaseVariableService);
    // this.Viewport = this.injector.get(Viewport);

    // register functions for binding evaluation
    this.registerExpressions();
    this.initUserScript();

    this.registerWidgets();
    // this.initVariables();

    this.App.lastActivePageName = this.App.activePageName;
    this.App.activePageName = this.pageName;
    this.App.activePage = this;
    this.activePageName = this.pageName; // Todo: remove this

    this.registerPageParams();
    this.defineI18nProps();
    super.init();
  }

  get Variables() {
    return {...this.baseVariableService.variableInstanceCollection[this.pageName], ...this.baseVariableService.variableInstanceCollection['App']};
  }

  registerWidgets() {
    // common partial widgets should be accessible from page
    this.Widgets = Object.create(commonPartialWidgets);

    // expose current page widgets on app
    (this.App as any).Widgets = Object.create(this.Widgets);
  }

  registerPageParams() {
    const subscription = this.route.queryParams.subscribe(params => this.pageParams = (this.App as any).pageParams = extend({}, params));
    this.registerDestroyListener(() => subscription.unsubscribe());
  }

  registerDestroyListener(fn: Function) {
    this.destroy$.subscribe(noop, noop, () => fn());
  }
  //
  // initVariables() {
  //   const variablesService = this.injector.get(VariablesService);
  //
  //   // get variables and actions instances for the page
  //   const variableCollection = variablesService.register(this.pageName, this.getVariables(), this);
  //
  //   // create namespace for Variables nad Actions on page/partial, which inherits the Variables and Actions from App instance
  //   this.Variables = Object.create(this.App.Variables);
  //   this.Actions = Object.create(this.App.Actions);
  //
  //   // assign all the page variables to the pageInstance
  //   Object.entries(variableCollection.Variables).forEach(([name, variable]) => this.Variables[name] = variable);
  //   Object.entries(variableCollection.Actions).forEach(([name, action]) => this.Actions[name] = action);
  //
  //
  //
  //   const subscription = this.viewInit$.subscribe(noop, noop, () => {
  //
  //     if (!this.appManager.isAppVariablesFired()) {
  //       variableCollection.callback(this.App.Variables).catch(noop).then(() => {
  //         this.appManager.notify('app-variables-data-loaded', {pageName: this.pageName});
  //       });
  //       variableCollection.callback(this.App.Actions);
  //       this.appManager.appVariablesReady();
  //       this.appManager.isAppVariablesFired(true);
  //     }
  //
  //     variableCollection.callback(variableCollection.Variables)
  //       .catch(noop)
  //       .then(() => {
  //         this.appManager.notify('page-variables-data-loaded', {pageName: this.pageName});
  //         this.startupVariablesLoaded = true;
  //         // hide the loader only after the some setTimeout for smooth page load.
  //         setTimeout(() => {
  //           this.showPageContent = true;
  //         }, 100);
  //       });
  //     variableCollection.callback(variableCollection.Actions);
  //
  //     subscription.unsubscribe();
  //   });
  // }

  initUserScript() {}

  /**
   * function to register bind expressions generated in this page instance
   * getExpressions function is defined in the generated page.comp.ts file
   * @param expressions, map of bind expression vs generated function
   */
  registerExpressions() {
    const expressions = this.getExpressions();
    each(expressions, (fn, expr)=>{
      registerFnByExpr(expr, fn[0], fn[1]);
    });
  }

  get appLocale() {
    return this.i18nService.appLocale;
  }

  defineI18nProps() {
    // this.appLocale = this.i18nService.getAppLocale();
  }

  static clear() {
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    (this as any).compilePageContent = true;
    setTimeout(() => {
      this.onPageContentReady = () => {
        this.fragmentsLoaded$.subscribe(noop, noop, () => {
          this.invokeOnReady();
        });
        unMuteWatchers();
        this.viewInit$.complete();
        this.onPageContentReady = noop;
      };
    }, 0);
    this.showPageContent = true;
  }

  invokeOnReady() {
    this.onReady();
    this.appManager.notify('pageReady', {'name' : this.pageName, instance: this});
    (this.App.onPageReady || noop)(this.pageName, this);
  }

}
